module.exports = __webpack_public_path__ + "static/media/soup.e73186ea.svg";